var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconIntrusionExtrusion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8C15.5 8.27614 15.7239 8.5 16 8.5C16.2761 8.5 16.5 8.27614 16.5 8L15.5 8ZM16 0L13.1132 5L18.8868 5L16 0ZM16.5 8L16.5 4.5L15.5 4.5L15.5 8L16.5 8Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6543 25.9687C18.7819 25.9896 18.9043 26 19.0266 26C19.9681 26 20.766 25.3419 20.9894 24.4384C21.7766 21.2317 24 13.5649 24 11.5803C24 9.0525 21.9096 7 19.3351 7C18.6809 7 18.0585 7.13057 17.4947 7.37081C17.0213 7.56927 16.5106 7.67372 16 7.67372C15.4894 7.67372 14.9787 7.57449 14.5053 7.37081C13.9415 7.13057 13.3191 7 12.6649 7C10.0904 7 8 9.0525 8 11.5803C8 13.3194 10.2021 21.2317 10.9734 24.4384C11.1915 25.3419 11.9894 26 12.9362 26C13.0585 26 13.1862 25.9896 13.3138 25.9634C14.2713 25.7859 14.9362 24.9241 14.9362 23.9684V21.7905C14.9362 20.9601 15.4043 20.5006 15.984 20.5006C16.5638 20.5006 17.0319 20.9601 17.0319 21.5294V23.9684C17.0319 24.9241 17.6968 25.7911 18.6596 25.9687H18.6543Z",
    fill: "#70A4D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16C16.5 15.7239 16.2761 15.5 16 15.5C15.7239 15.5 15.5 15.7239 15.5 16L16.5 16ZM16 32L18.8868 27L13.1132 27L16 32ZM15.5 16L15.5 27.5L16.5 27.5L16.5 16L15.5 16Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIntrusionExtrusion);
export default __webpack_public_path__ + "static/media/Icon_Intrusion_Extrusion.bdc470c1c8dedd3339827f6ad3aec185.svg";
export { ForwardRef as ReactComponent };